import { useCurrency } from "@/hooks/useCurrency";
import { useLocale } from "@/store/locale-store";
import { useProducts } from "@/services/product/useProductService";
import {
  isReferralActiveForProduct,
  useReferralDiscount,
} from "@/hooks/useReferralDiscount";
import { ProductUtil } from "@/utils/ProductUtil";
import { useMemo } from "react";

export function useProductTags() {
  const currency = useCurrency();
  // 가격 조회는 반드시 countryCode 를 함께 넘긴다 — 국가별 티어(usPrice/euPrice/gbPrice)를
  // 건너뛰면 EU/GB 에서 `null` 이 되어 배지가 통째로 사라진다. docs/pricing-tiers.md §3.2
  const { countryCode } = useLocale();
  const products = useProducts();
  const { referralDiscountPercentile } = useReferralDiscount();

  const getProductTagsBySlug = useMemo(() => {
    return (slug: string): string[] | null => {
      const product = products.data?.find((p) => p.slug === slug);
      const referralActive = isReferralActiveForProduct(slug);
      const furtherDiscountPercentile = referralActive
        ? referralDiscountPercentile
        : 0;
      const price = product
        ? ProductUtil.getProductPrice({
            currency,
            countryCode,
            product,
            furtherDiscountPercentile,
          })
        : null;

      if (!product || !price) {
        return null;
      }

      const tags: string[] = [];
      if (furtherDiscountPercentile) {
        tags.push(`Ref. ${Math.round(furtherDiscountPercentile * 100)}%`);
      }
      tags.push(...product.tags);

      return tags.slice(0, 2);
    };
  }, [products.data, currency, countryCode, referralDiscountPercentile]);

  return { getProductTagsBySlug };
}
